import styled from "styled-components";
import rtan from "./PoorRtan.png"

const Img = styled.img`
      width: 328px;
  flex-grow: 0;
  object-fit: contain;

    `

export default () => (
    <Img src={rtan} alt={"부자 르탄"}/>
)
